
export function navigation(state , action) {
  if (action.type === "CHANGE_ROUTE") {
    return {
      ...state,
      title: action.title,
      text: action.text,
      route: action.route
    };
  }

  return state;
}